import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
declare const swal: any;
declare var $: any;
interface Admin {
  name: string;
  username: string;
  email: string;
  password: string;
  role: string;
  status: boolean;
  id?: string;
}
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  admindata: Observable<Admin[]>;
  id:any;
  constructor(private afs: AngularFirestore) { }

  ngOnInit() {
    try{
    const admins: AngularFirestoreCollection<Admin> = this.afs.collection<Admin>('admin',res =>{
      console.log("gj")

      return res.orderBy('createdAt', 'desc');
      
    });
     this.admindata = admins.valueChanges();
  }catch(error){
    console.log(error)
  }
  }
  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
      this.afs.doc('/admin/'+this.id).delete().then(function () {  
        swal('Deleted!', 'Your List has been deleted.', 'success');
      }).catch(function(error){
        swal('Error!', error, 'error');
        console.error("error in removing document:",error);
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/admins/admin/admin.component.ts